module.exports = __webpack_public_path__ + "static/img/how-it-work-new-property.544090f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/how-it-work-new-property.png
// module id = 4GCN
// module chunks = 0